import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCConsultDetranComponent = class UiCConsultDetranComponent {
    constructor() {
        /* @Input() consultForm: FormGroup; */
        /* @Output() stateSelected = new EventEmitter(); */
        this.selectedOperation = new EventEmitter();
    }
    ngOnInit() { }
    operationSelected(item) {
        this.selectedOperation.emit(item);
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCConsultDetranComponent.prototype, "listOperations", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCConsultDetranComponent.prototype, "selectedOperation", void 0);
UiCConsultDetranComponent = __decorate([
    Component({
        selector: 'ui-c-consult-detran',
        template: "<div class=\"consult-detran\">\n  <h4 class=\"ion-text-center title\">\n    {{'CASH_OUT.DETRAN.TEXT.INFO_CONSULT_DATA'| wlpTranslate}}\n  </h4>\n  <ion-list>\n\n    <ion-item *ngFor=\"let item of listOperations\" (click)=\"operationSelected(item)\">\n      <ion-label>\n        {{item.description}}\n      </ion-label>\n      <ion-icon slot=\"end\" name=\"arrow-forward-outline\"></ion-icon>\n    </ion-item>\n    <!--  <ion-item>\n        <ion-label position=\"floating\">\n          {{'CASH_OUT.DETRAN.LABELS.SELECT_STATE'| wlpTranslate}}\n        </ion-label>\n        <ion-select [okText]=\"'CASH_OUT.DETRAN.BUTTONS.OK'| wlpTranslate\"\n          [cancelText]=\"'CASH_OUT.DETRAN.BUTTONS.CANCEL'| wlpTranslate\" formControlName=\"uf\"\n          (ionChange)=\"selectedState($event)\">\n          <ion-select-option style=\"white-space: pre-wrap !important;\" *ngFor=\"let item of listStates\"\n            value=\"{{item.uf}}\">{{item.name}}</ion-select-option>\n        </ion-select>\n      </ion-item> -->\n\n    <!--  <ion-item>\n        <ion-label position=\"floating\">\n          {{'CASH_OUT.DETRAN.LABELS.SELECT_OPERATION'| wlpTranslate}}\n        </ion-label>\n        <ion-select [okText]=\"'CASH_OUT.DETRAN.BUTTONS.OK'| wlpTranslate\"\n          [cancelText]=\"'CASH_OUT.DETRAN.BUTTONS.CANCEL'| wlpTranslate\" formControlName=\"operation\"\n          (ionChange)=\"operationSelected($event)\">\n          <ion-select-option style=\"white-space: pre-wrap !important;\" *ngFor=\"let item of listOperations\"\n            value=\"{{item.code}}\">{{item.description}}\n          </ion-select-option>\n        </ion-select>\n      </ion-item> -->\n\n    <!-- <ion-item>\n        <ion-label> {{'CASH_OUT.DETRAN.LABELS.RENAVAM'| wlpTranslate}}</ion-label>\n        <ion-input type=\"number\" formControlName=\"renavam\" placeholder=\"renavam\"></ion-input>\n      </ion-item> -->\n  </ion-list>\n</div>",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCConsultDetranComponent);

let UiCConsultDetranModule = class UiCConsultDetranModule {
};
UiCConsultDetranModule = __decorate([
    NgModule({
        declarations: [UiCConsultDetranComponent],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            NgxMaskIonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCConsultDetranComponent]
    })
], UiCConsultDetranModule);

export { UiCConsultDetranComponent, UiCConsultDetranModule };
//# sourceMappingURL=wlp-ui-c-consult-detran.js.map
